module.exports = __webpack_public_path__ + "static/media/LeftArrowIcon.95e5f24f.svg";